import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { startCase } from 'lodash/fp';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './RoleList.scss';
import EditButton from './EditButton';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';

class RoleList extends PureComponent {
  actionFormatter = (cell, role) => (
    <EditButton
      role={role}
      onEdit={this.props.onEdit}
      onDelete={this.props.onDelete}
    />
  );

  childRolesFormatter = (cell, row) => {
    const accessibleRoles = row.accessibleRoles || [];
    return (
      <div>
        {accessibleRoles.map((role) => (
          <div> {startCase(role)} </div>
        ))}
      </div>
    );
  };

  render() {
    const { list, error, success } = this.props;

    const options = {
      defaultSortName: 'role',
      defaultSortOrder: 'asc',
    };

    return (
      <div className="role-list-container">
        {error && <ErrorMessage error={error} />}
        {success && <SuccessMessage success={success} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn
            isKey
            dataField="role"
            dataSort
            filter={{ type: 'TextFilter', defaultValue: '' }}
            dataFormat={startCase}
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="accessibleRoles"
            dataFormat={this.childRolesFormatter}
          >
            Accessible Roles
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

RoleList.propTypes = {
  error: PropTypes.any,
  success: PropTypes.any,
  list: PropTypes.array,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default withRouter(RoleList);
